<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        الكورسات
        <v-spacer></v-spacer>

        <v-text-field rounded v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        <div style="width: 20px"></div>
        <AddCourse @reloadTask="initialData()" :trainingCenter="trainingCenter" :teachers="teachers" />
      </v-card-title>
      <v-data-table :headers="headers" :items="ItemsFilter" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="dialog = false">
            <DeleteCourse :dataToDelete="item" @reloadTask="initialData()" v-if="$store.state.userData.roleId == 1" />
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import AddCourse from "./course/AddCourse.vue";
import DeleteCourse from "./course/DeleteCourse.vue";
export default {
  components: {
    AddCourse,
    DeleteCourse,
  },
  props: {
    trainingCenter: Number,
  },
  data: () => ({
    overlay: false,
    search: "",
    resources: [],
    headers: [
      { text: "التسلسل", value: "index" },
      { text: "اسم الكورس", value: "courseName" },
      { text: "وقت بدء الكورس", value: "startDateFormat" },
      { text: "مدة الكورس", value: "duration" },
      { text: "التكلفة", value: "courseCost" },
      { text: "الاستاذ", value: "teacherName" },
      { text: "الوصف", value: "courseDescription" },
      { text: "الاجراءات", value: "actions" },
    ],
    currencies: [],
    resources: [],
    teachers: [],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.overlay = true;

      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrl}/courseTrainingCenter/${self.trainingCenter}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrl}/teachersCenter/${self.trainingCenter}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((resources, teachers) => {
            self.resources = resources.data;
            self.teachers = teachers.data;
            self.overlay = false;
          })
        )
        .catch((error) => {
          self.overlay = false;
          console.log(error);
        });
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.resources.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.sectionName.toLowerCase().includes(v));
        });
      } else {
        return this.resources;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
